var map = {
	"./chain_arbitrum.png": 72924,
	"./chain_bsc.png": 59492,
	"./chain_dark_uptick.png": 38153,
	"./chain_eth.png": 73090,
	"./chain_iris.png": 72472,
	"./chain_polygon.png": 96817,
	"./chain_uptick.png": 98242,
	"./chian_weth.png": 26181,
	"./logo_arbitrum.png": 43608,
	"./logo_arbitrum1.png": 24919,
	"./logo_bsc.png": 95716,
	"./logo_bsc1.png": 87713,
	"./logo_irisnet.png": 97596,
	"./logo_irisnet1.png": 44680,
	"./logo_polygon.png": 71613,
	"./logo_polygon1.png": 16564,
	"./logo_uptickchain.png": 92279,
	"./logo_uptickchain1.png": 64339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65021;